import { isEmpty } from 'lodash'
import { FETCH_COMPLIANCE_FAIL, FETCH_COMPLIANCE_SUCCESS, FETCH_COMPLIANCE_LOADING } from '../actions/types'

const INITIAL_STATE = {
  loading: true,
  fail: false,
  data: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_COMPLIANCE_LOADING:
      return { fail: false, loading: true, data: null }

    case FETCH_COMPLIANCE_SUCCESS:
      const data = isEmpty(action.payload) ? null : action.payload
      return { fail: false, loading: false, data: { ...state.data, ...data } }

    case FETCH_COMPLIANCE_FAIL:
      return { fail: true, loading: false, data: null }

    default:
      return state
  }
}
